module.exports = __webpack_public_path__ + "cfa26367.webp";